import { Quota } from '../models/survey-quota.model';
export class SurveyQuotas {
  constructor(private readonly _quotas: readonly Quota[]) {}

  public qualificationIds(): ReadonlySet<number> {
    return new Set(this._quotas.flatMap((quota) => this._codesOf(quota)));
  }

  public withQualification(qualificationCode: number): readonly Quota[] {
    return this._quotas.filter((quota) =>
      this._codesOf(quota).includes(qualificationCode),
    );
  }

  private _codesOf(quota: Quota): number[] {
    return quota.criteria.map((criterion) =>
      Number(criterion.qualificationCode),
    );
  }
}
